import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'

import { Flex } from 'reflexbox'
import Title from 'components/typography/title/index'

import styles from './styles.scss'

const CardHeader = ({title, rightOfTitle, children}) => {
  return (
    <Flex styleName='cardHeader' justify='space-between' align='center'>
      <Flex styleName='innerFlex'><Title>{ title }</Title>{ rightOfTitle }</Flex>
      { children }
    </Flex>
  )
}

export default CSSModules(styles, CardHeader)
